<template>
  <search-group @search="findData" @clear="clearValue" :span="24" :btnSpan="6" :inline="true" :btnOffset="21">
    <Row class="mb16" :gutter="16">
      <Col span="5">
        <Select v-model="searchData.moduleFid" placeholder="请选择项目">
          <Option value>请选择</Option>
           <Option
            v-for="({value,text},index) in projectList"
            :key="'prj1'+index"
            :value="value"
          >{{text}}</Option>
          <!-- <Option v-for="({text,value},index) in yyList" :key="'aud'+index" :value="value">{{text}}</Option> -->
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.signType" placeholder="拼团类型">
          <Option value>请选择</Option>
           <Option
            v-for="({value,text},index) in groupTypeList"
            :key="'prj2'+index"
            :value="value"
          >{{text}}</Option>
          <!-- <Option v-for="({text,value},index) in yyList" :key="'aud'+index" :value="value">{{text}}</Option> -->
        </Select>

      </Col>
      <Col span="4">
        <Select v-model="searchData.participateStatus" placeholder="拼团状态">
          <Option value>请选择</Option>
           <Option
            v-for="({value,text},index) in groupStatusList"
            :key="'prj3'+index"
            :value="value"
          >{{text}}</Option>
          <!-- <Option v-for="({text,value},index) in yyList" :key="'aud'+index" :value="value">{{text}}</Option> -->
        </Select>
      </Col>
       <Col span="4">
        <Input v-model="searchData.customerInfoStr" type="text" @keyup.enter.native="findData" placeholder="请输入客户姓名或电话"></Input>
      </Col>
    </Row>
  </search-group>
</template>

<script>
import SearchGroup from "components/SearchGroup/index";
import { mapGetters } from 'vuex'
export default {
  components: {
    SearchGroup
  },
  data() {
    return {
      //查询数据参数
      searchData: {
        moduleFid:'',
        signType:'',
        participateStatus:'',
        customerInfoStr:'',
      },
      groupTypeList:[
        {
          text:'新签',
          value:1,
        },
        {
          text:'续约',
          value:2,
        },
      ],
      groupStatusList:[
        {
          text:'拼团中',
          value:1,
        },

        {
          text:'拼团成功',
          value:2,
        },
        {
          text:'已取消',
          value:3,
        },
      ]
    };
  },
  computed:{
      ...mapGetters(['projectList']),
    },
    created(){
      this.searchData.moduleFid = this.projectList[0].value
      this.$emit('search',this.searchData)
    },
  methods: {
    findData() {
     this.$emit('search',this.searchData)   
    },
    clearValue() {
      this.searchData = {
        moduleFid: this.searchData.moduleFid,
        signType: '',
        participateStatus: '',
        customerInfoStr: '',
      };
    },
  },
  // watch: {
  //   projectList(val) {
  //     if (val && val.length) {
  //       this.searchData.moduleFid = val[0].value
  //       if (this.$route.params.projectFid) {
  //         this.searchData.projectFid = this.$route.params.projectFid;
  //       }
  //     }
  //   }
  // },
};
</script>

<style>
</style>